const ROOT_TELEMETRY_KEY = 'seoContainer';

export const EMPTY_SEO_TEXT_KEY = `${ROOT_TELEMETRY_KEY}.emptySeoText`;
export const HAS_SEO_TEXT_KEY = `${ROOT_TELEMETRY_KEY}.hasSeoText`;

export const EMPTY_SEO_URLS_KEY = `${ROOT_TELEMETRY_KEY}.emptySeoUrls`;
export const HAS_SEO_URLS_KEY = `${ROOT_TELEMETRY_KEY}.hasSeoUrls`;
